/* eslint-disable max-len */
import classNames from 'classnames';
import React from 'react';

export const AddIcon = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => {
  return (
    <i className={classNames('bookriver-icon-AddIcon', className)} {...props} />
  );
};
